<template>
  <div>
    <div>
      <h6>Filters</h6>
      <form :class="[isLoading ? 'table-active' : '']">
        <div class="row">
          <div class="col-md-12 col-lg-4 mb-3">
            <label for="firstname" class="form-label" style="text-transform: capitalize;">Firstname:</label>
            <input type="text" class="form-control" id="firstname" v-model="form.firstname" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="lastname" class="form-label">Lastname:</label>
            <input type="text" class="form-control" id="lastname" v-model="form.lastname" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="username" class="form-label">Username:</label>
            <input type="text" class="form-control" id="username" v-model="form.username" />
          </div>
          <div class="col-md-12 col-lg-4 mb-3">
            <label for="maxrecords" class="form-label" style="text-transform: capitalize;">Max Records:</label>
            <select class="form-control" id="maxrecords" v-model="form.searchlimit">
              <option value="5">Top 5</option>
              <option value="10">Top 10</option>
              <option value="20">Top 20</option>
              <option value="50">Top 50</option>
              <option value="ALL">ALL</option>
            </select>
          </div>
          <div class="col-md-12 col-lg-4 mb-3">
            <label for="maxrecords" class="form-label">Go back:</label>
            <select class="form-control" id="maxrecords">
              <option selected value="0">Select days to go back</option>
              <option v-for="(n, index) in 60" :key="index" :value="n.index"> {{ n }} days </option>
            </select>
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="maxrecords" class="form-label">Platform:</label>
            <select class="form-control" id="maxrecords" v-model="form.platform">
              <option value="" selected="">Select platform</option>
              <option value="Desktop">Desktop</option>
              <option value="Android">Android</option>
              <option value="iOS">iOS</option>
            </select>
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="userorderid" class="form-label">User Order Id:</label>
            <input type="text" class="form-control" id="userorderid" v-model.number="form.userorderid" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="orderno" class="form-label">Order Number:</label>
            <input type="text" class="form-control" id="orderno" v-model="filters.list" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="trackingno" class="form-label">Tracking Number:</label>
            <input type="text" class="form-control" id="trackingno" v-model="form.trackingnumber" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="invoiceno" class="form-label">Invoice Number:</label>
            <input type="text" class="form-control" id="invoiceno" v-model="form.invoicenumber" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="billingcode" class="form-label">Billing Code:</label>
            <input type="text" class="form-control" id="billingcode" v-model="form.billingcode" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label class="form-check-label mb-2" for="giftitem">Gift Item:</label>

            <b-form-checkbox id="giftitem" v-model="form.isgift" :true-value="true" :false-value="false" switch />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="sDate" class="form-label">Order Date Range From:</label>
            <input type="date" name="startdate" class="form-control" v-model="filters.sDate" @change="startDate" />
          </div>

          <div class="col-md-12 col-lg-4 mb-3">
            <label for="eDate" class="form-label">Order Date Range To:</label>
            <input type="date" class="form-control" name="enddate" v-model="filters.eDate" @change="endDate" />
          </div>

          <div class="col-md-12 col-lg-2 mb-3">
            <label class="form-check-label mb-2" for="list">List:</label>

            <b-form-checkbox id="list" v-model="filters.islist" :true-value="true" :false-value="false" switch />
          </div>

          <div class="col-md-12 col-lg-2 mb-3">
            <label class="form-check-label mb-2" for="bbo">Unplaced BBO:</label>
            <b-form-checkbox id="bbo" v-model="unplacedBestBuyOrder" :true-value="true" :false-value="false" switch />
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12 col-lg-3 mb-3">
            <select class="form-control" multiple size="8" v-model.number="form.supplierids">
              <option value="0">Select supplier</option>
              <option v-for="supplier in allSuppliers.Result" :key="supplier.id" :value="supplier.id">
                {{ supplier.name }}
              </option>
            </select>
          </div>
          <div class="col-md-12 col-lg-3 mb-3">
            <select class="form-control" multiple size="8" v-model.number="form.clientids">
              <option value="0">Select Company</option>
              <option v-for="company in allClients" :key="company.id" :value="company.id" v-html="company.name"> </option>
            </select>
          </div>
          <div class="col-md-12 col-lg-3 mb-3">
            <select class="form-control" multiple size="8" v-model="form.statuscodes">
              <option value="-1">Choose Status Code</option>
              <option v-for="code in allStatusCodes" :key="code.id" :value="code.statusCode"> ({{ code.statusCode }}) {{ code.statusValue }} </option>
            </select>
          </div>

          <div class="col-md-12 col-lg-3 mb-3">
            <select class="form-control" multiple size="8" v-model="form.orderstatuscodes">
              <option value="0">Choose Order Status</option>
              <option v-for="status in allOrderStatus" :key="status.id" :value="status.statusCode">
                {{ status.orderstatus }}
              </option>
            </select>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12 col-lg-4 mb-3">
            <select class="form-control">
              <option value="0">--Select--</option>
              <option v-for="search in allSavedSearches" :key="search.search_id">
                {{ search.title }}
              </option>
            </select>
          </div>

          <div class="col-md-12 col-lg-2 mt-1 mb-3">
            <button type="button" class="btn btn-sm btn-primary" style="text-transform: capitalize;">
              Use Saved Search
            </button>
          </div>

          <div class="col-md-12 col-lg-6 mb-3 d-flex justify-content-end">
            <input type="submit" value="New search" class="btn btn-primary" @click="onClick($event)" />
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12 col-lg-4 mb-3 mt-1">
            <label for="searchtracking" class="form-label" style="text-transform: capitalize;">Search Tracking Numbers:</label>
            <input type="text" class="form-control" id="searchtracking" v-model="form.trackingnumber" />
          </div>
          <div class="col-md-12 col-lg-2 mt-4">
            <input type="button" class="btn btn-sm btn-primary mt-1" value="Search" @click="onClick($event)" />
          </div>
        </div>
      </form>
    </div>
    <div v-if="isLoading === true">
      <div class="centered-spinner">
        <a-spin />
      </div>
    </div>
    <div id="orders-list" v-else>
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: 'CustomerOrdersForm',
  data() {
    return {
      isLoading: false,
      unplacedBestBuyOrder: false,
    };
  },
  methods: {
    onClick(e) {
      e.preventDefault();
      this.isLoading = true;

      const list = this.filters.list;
      if (list.trim() === '') {
        this.form.ordernumbers = [];
      } else {
        if (this.filters.islist === true) {
          let arrList = list.trim().split(',');
          // console.log(arrList);
          this.form.ordernumbers = arrList;
          // console.log(this.form.ordernumbers);
        } else {
          this.form.ordernumbers = [list];
        }
      }

      // to remove values of default options in dropdown
      this.form.supplierids = this.form.supplierids.filter((id) => id !== 0);
      this.form.statuscodes = this.form.statuscodes.filter((code) => code !== '-1');
      this.form.clientids = this.form.clientids.filter((id) => id !== 0);
      this.form.orderstatuscodes = this.form.orderstatuscodes.filter((code) => code !== '0');

      // to send null when userorderid is empty ""
      if (typeof this.form.userorderid === 'string' && this.form.userorderid.trim() === '') {
        this.form.userorderid = null;
      }

      this.form.unplacedBestBuyOrder = this.unplacedBestBuyOrder;
      
      this.$store.dispatch('customerOrders/fetchCustomerOrders', this.form).then((data) => {
        this.isLoading = false;
        if (data.hasOwnProperty('Result'))
          this.$router
            .push({
              name: 'CustomerOrdersResult',
              params: {
                form: this.form,
              },
            })
            .catch(() => {})
            .then(() => {
              const el = document.getElementById('orders-list');
              el.scrollIntoView({ behavior: 'smooth' });
            });
        else
          this.$error({
            title: 'Error occured while fetching results.',
            content: data.message,
          });
      });
    },
  },

  computed: {
    filters() {
      return this.$store.state.customerOrders.filters;
    },
    form() {
      return this.$store.state.customerOrders.form;
    },
    allSuppliers() {
      return this.$store.getters['manageSuppliers/allSuppliers'];
    },
    allClients() {
      return this.$store.getters['customerOrders/allClients'];
    },
    allStatusCodes() {
      return this.$store.getters['customerOrders/allStatusCodes'];
    },
    allOrderStatus() {
      return this.$store.getters['customerOrders/allOrderStatus'];
    },
    allSavedSearches() {
      return this.$store.getters['customerOrders/allSavedSearches'];
    },
    startDate() {
      if (this.filters.sDate) {
        var jsObj = JSON.parse(JSON.stringify(this.filters.sDate));
        var dt = new Date(jsObj);
        var newDate = dt.toISOString();
        this.form.startdate = newDate;
        return this.form.startdate;
      } else {
        return '';
      }
    },
    endDate() {
      if (this.filters.eDate) {
        var jsObj = JSON.parse(JSON.stringify(this.filters.eDate));
        var dt = new Date(jsObj);
        var newDate = dt.toISOString();
        this.form.enddate = newDate;
        return this.form.enddate;
      } else {
        return '';
      }
    },
  },
  mounted() {
    this.$store.dispatch('manageSuppliers/fetchAllSuppliers', {
      searchTerm: '',
      pageNumber: 1,
      pageSize: 100,
      sortField: '[NAME]',
      sortOrder: 'ASC',
    });
    this.$store.dispatch('customerOrders/getClients');
    this.$store.dispatch('customerOrders/fetchStatusCodes');
    this.$store.dispatch('customerOrders/fetchCustomerOrderStatus');
    this.$store.dispatch('customerOrders/fetchSavedSearches');
  },
  destroyed() {
    if (this.$route.name !== 'OrderDetails' && this.$route.name !== 'CustomerOrders' && this.$route.name !== 'CustomerOrdersResult') {
      this.$store.state.customerOrders.customerOrders = null;
      this.$store.state.customerOrders.form = {
        startdate: '',
        billingcode: '',
        clientids: [],
        enddate: '',
        firstname: '',
        invoicenumber: '',
        isgift: false,
        lastname: '',
        ordernumbers: [],
        orderstatuscodes: [],
        supplierids: [],
        statuscodes: [],
        trackingnumber: '',
        username: '',
        userorderid: null,
        platform: '',
        pageNumber: 1,
        pageSize: 10,
        sortField: 'ORDERDATE',
        sortOrder: 'DESC',
        searchlimit: '50',
      };
      this.$store.state.customerOrders.filters = {
        list: '',
        islist: false,
        sDate: '',
        eDate: '',
      };
    }
  },
};
</script>
<style lang="scss" scoped>
form {
  border: 1px solid #ccc;
  padding: 25px;
  border-radius: 5px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
  margin-left: -1.5em !important;
}

.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 9999;
}

.table-active {
  opacity: 0.5;
}
</style>
